export function artistbar_mouseIn() {
$w("#artistbar").show();
}

export function artistbar_mouseOut() {
$w("#artistbar").hide();
}

export function artistbutton_mouseIn() {
    $w('#artistbar').show()
}

export function artistbutton_mouseOut() {
    $w('#artistbar').hide()
}
